// A minimal async mutex, like the one LiveKit uses for track changes.
export class Mutex {
	#tail: Promise<void> = Promise.resolve();

	async lock(): Promise<() => void> {
		let release!: () => void;
		const next = new Promise<void>((resolve) => {
			release = resolve;
		});
		const previous = this.#tail;
		this.#tail = previous.then(() => next);
		await previous;
		return release;
	}
}
